/*
 * @Descripttion:
 * @Author: yeyancheng
 * @Date: 2022-01-22 09:20:10
 * @LastEditors: Dom
 * @LastEditTime: 2022-06-15 10:09:35
 */
export default {
  'index-layout.topmenu.userinfo': '个人信息',
  'index-layout.topmenu.logout': '退出',
  'index-layout.topmenu.notcertified': '未认证',
  'index-layout.topmenu.certifing': '认证中',
  'index-layout.topmenu.certified': '已认证',
  'index-layout.topmenu.certifiedfail': '认证失败',

  'index-layout.menu.home': '首页',
  'index-layout.menu.home.workplace': '工作台',
  'index-layout.menu.home.custom-breadcrumbs': '项目管理',
  'index-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'index-layout.menu.home.docs': 'admin-antd-vue',

  'index-layout.menu.component': '组件',
  'index-layout.menu.component.icon': '图标',
  'index-layout.menu.component.icon.svg': 'IconSvg',
  'index-layout.menu.component.icon.font': 'IconFont',
  'index-layout.menu.component.editor': '编辑器',
  'index-layout.menu.component.editor.tui-editor': 'tui-editor',
  'index-layout.menu.component.editor.ckeditor': 'CKEditor',

  'index-layout.menu.pages': '页面示例',
  'index-layout.menu.pages.list': '列表页面',
  'index-layout.menu.pages.list.basic': '标准列表',
  'index-layout.menu.pages.list.table': '表格列表',
  'index-layout.menu.pages.list.highly-adaptive-table': '高度自适应表格',
  'index-layout.menu.pages.list.search': '搜索列表',
  'index-layout.menu.pages.list.search.table': '查询表格',
  'index-layout.menu.pages.form': '表单页面',
  'index-layout.menu.pages.form.basic': '基础表单',
  'index-layout.menu.pages.form.complex': '高级表单',
  'index-layout.menu.pages.detail': '详情页面',
  'index-layout.menu.pages.detail.basic': '基础详情',
  'index-layout.menu.pages.detail.module': '模块详情',
  'index-layout.menu.pages.detail.table': '表格详情',

  'index-layout.menu.roles': '权限验证',
  'index-layout.menu.roles.all': '用户都有权限',
  'index-layout.menu.roles.user': 'Users有权限',
  'index-layout.menu.roles.test': 'Tests有权限',

  'index-layout.menu.roles.personal': '个人中心',
  'index-layout.menu.roles.personal.account': '账号信息',
  'index-layout.menu.roles.account': '账户管理',
  'index-layout.menu.roles.account.query': '账户信息查询',
  'index-layout.menu.roles.account.recharge': '账户充值记录',
  'index-layout.menu.roles.account.logistics': '物流费用清单',
  'index-layout.menu.roles.logistics': '物流单管理',
  'index-layout.menu.roles.logistics.sku': 'SKU管理',
  'index-layout.menu.roles.logistics.erp': 'ERP绑定',
  'index-layout.menu.roles.logistics.query': '物流单查询',
  'index-layout.menu.roles.logistics.collectbill': '揽收单管理',
  'index-layout.menu.roles.logistics.address': '地址管理',

  'index-layout.menu.roles.tms': '运输管理',
  'index-layout.menu.roles.tms.airlineorderment': '航空主单号管理',
  'index-layout.menu.roles.tms.datamanagement': '交航数据推送',
  'index-layout.menu.roles.tms.systemlogs': '数据日志',
};
